import { Injectable } from '@angular/core';
import {
  NotificationService,
  NotificationSettings,
} from '@progress/kendo-angular-notification';
import { EsriHelpers } from '../../_helpers/EsriHelpers';

type MessageType = 'info' | 'success' | 'error';

@Injectable({
  providedIn: 'root',
})
export class MessageService {
  private readonly maxMessage = 100;
  private readonly messages: string[];
  private numberOfMessages = 0;

  constructor(private service: NotificationService) {
    this.messages = new Array<string>(this.maxMessage);
  }

  public info(message: string): void {
    this.add(message, 'info');
  }

  public success(message: string): void {
    this.add(message, 'success');
  }

  public error(message: string): void {
    this.add(message, 'error');
  }

  private add(message: string, type: MessageType): void {
    if (this.numberOfMessages < 100) {
      this.numberOfMessages++;
      this.messages.push(message);
      this.notify(message, type);
    } else {
      this.messages.shift();
      this.numberOfMessages--;
    }
  }

  private notify(message: string, type: MessageType): void {
    const settings: NotificationSettings = {
      content: EsriHelpers.formatDate(new Date(), true, true) + ' : ' + message,
      position: { horizontal: 'left', vertical: 'bottom' },
      closable: true,
      animation: { type: 'slide', duration: 400 },
      width: window.screen.width / 3,
    };
    switch (type) {
      case 'info':
        settings.type = { style: 'info', icon: true };
        settings.cssClass = 'message-info';
        break;
      case 'success':
        settings.closable = false;
        settings.type = { style: 'success', icon: true };
        settings.cssClass = 'message-success';
        break;
      case 'error':
        settings.type = { style: 'error', icon: true };
        settings.cssClass = 'message-error';
        break;
    }

    this.service.show(settings);
  }
}
